import Stream from '../libs/Stream';


let selectOrderItemActionStream: Stream<number> = new Stream() as Stream<number>;

export default selectOrderItemActionStream;
